import axios from 'axios';
import store from '@/store/store';
const ACCESS_DENIED_MESSAGE = 'Access denied to this field.';

const getBaseUrl = () => {
  const url = global.API_URL || process.env.VUE_APP_API_URL;

  if (url) {
    return `${url}graphql`;
  }
};

const getRESTBaseUrl = () => {
  const url = global.API_URL || process.env.VUE_APP_API_URL;

  if (url) {
    return `${url}`;
  }
};

const config = {
  baseURL: getBaseUrl(),
  timeout: 3 * 6000, // 3 minutes,
  headers: {
    'Accept-Language': window.__INITIAL_STATE__.locale,
  },
};

const instance = axios.create(config);

export const anonymous = axios.create(config);
export const rest = axios.create({
  ...config,
  baseURL: getRESTBaseUrl(),
});
export default instance;

instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;
anonymous.CancelToken = axios.CancelToken;
anonymous.isCancel = axios.isCancel;

function authenticateRequest(config) {
  const token = store.state.token || process.env.VUE_APP_TOKEN;

  if (token) {
    config.headers['Authorization'] = token;
  }

  return config;
}

/**
 * Receives GraphQL response and rejects if there is no data and there are errors.
 *
 * @param response
 */
function handleGraphQLResponse({ data: results }) {
  const { data, errors, extensions } = results;
  const success = data ? Object.keys(data).filter((key) => data[key] !== null).length : 0;
  const forbidden =
    (errors?.find((e) => e.message === ACCESS_DENIED_MESSAGE) ?? extensions?.warnings?.find((w) => w.message === ACCESS_DENIED_MESSAGE)) !==
    undefined;

  if (forbidden) {
    window.location.href = `${window.BASE_URL}/login?error=session_expired`;
  }

  // We did not get any results, and there were errors so reject the response.
  if (!success && !forbidden && ((errors && errors.length) || (extensions.warnings && extensions.warnings.length))) {
    return Promise.reject({
      message: errors ? errors : extensions.warnings[0].message,
    });
  } else {
    return data;
  }
}

function handleError({ response, request, message }) {
  if (response) {
    const { status } = response;

    // Token rejected
    if (status === 401) {
      window.location.href = `${window.BASE_URL}/login?error=session_expired`;
    }

    return Promise.reject({
      error: status,
    });
  } else if (request) {
    return Promise.reject({
      error: request.status,
    });
  } else {
    return Promise.reject({
      error: message,
    });
  }
}

rest.interceptors.request.use(authenticateRequest, (error) => Promise.reject(error));

instance.interceptors.request.use(authenticateRequest, (error) => Promise.reject(error));

instance.interceptors.response.use(handleGraphQLResponse, handleError);
anonymous.interceptors.response.use(handleGraphQLResponse, ({ response, request, message }) => {
  if (response) {
    return Promise.reject({
      error: status,
    });
  } else if (request) {
    return Promise.reject({
      error: request.status,
    });
  } else {
    return Promise.reject({
      error: message,
    });
  }
});
